<template>
<v-container class="pa-0">
  <v-row>
    <v-col class="pa-0">
<v-layout justify-center>
<v-data-table
:headers="headers"
:items="pruebas"
sort-by="calories"
class="elevation-1"
:footer-props="{
  'items-per-page-text':'Filas por página'
}"
>
<template v-slot:top>
  <v-toolbar flat color="white">
    <v-toolbar-title>Listado de pruebas</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :disabled="![1,2].some(r => usuario.groups.includes(r))"
          color="primary"
          class="mb-2"
          v-bind="attrs"
          v-on="on"
        ><v-icon dark left>mdi-plus</v-icon>Nueva prueba</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field v-model="editedItem.nombrePrueba" label="Ingrese nombre"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group column>
                  <v-radio label="Comenzar desde cero" value="radio-1" @click="hidePick"></v-radio>
                  <v-radio label="Replicar otra prueba" value="radio-2" @click="showPick"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-show="pickList">
              <v-col>

                    <v-text-field
                      v-model="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>

                  <v-data-table
                    v-model="selected"
                    :headers="pickerHeaders"
                    :items="pruebas"
                    :single-select="singleSelect"
                    item-key="nombrePrueba"
                    show-select
                    class="elevation-1"
                    :items-per-page="5"
                    :search="search"
                  >
                  </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>
<template v-slot:item.nombrePrueba="{ item }">
  <router-link :to="'/prueba/' + item.id">{{item.nombrePrueba}}</router-link>
</template>
<template v-slot:item.timestamp="{ item }">
  {{toNormalDate(item.timestamp)}}
</template>
<template v-slot:item.actions="{ item }">
  <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" small @click="deleteItem(item)">mdi-delete</v-icon>
</template>
<template v-slot:no-data>
  No hay datos
</template>
</v-data-table>
</v-layout>
</v-col>
</v-row>
<v-row>
<!--
<v-col>
  <v-layout justify-center>
    <router-link :to="'imagenes/'">Configurar imágenes</router-link>
  </v-layout>
</v-col>
-->
</v-row>



</v-container>
</template>

<script>

  import moment from 'moment';

  export default {
    data: () => ({
      dialog: false,
      pickList: false,
      singleSelect: true,
      selected: [],
      search: '',
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'nombrePrueba',
        },
        { text: 'Fecha de creación', value: 'timestamp' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      pickerHeaders: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'nombrePrueba',
        },
      ],
      editedIndex: -1,
      editedItem: {
        nombrePrueba: '',
        timestamp: '',
      },
      defaultItem: {
        nombrePrueba: '',
        timestamp: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva prueba' : 'Edit Item'
      },
      pruebas() {
        return this.$store.state.pruebas
      },
      usuario() {
        return this.$store.state.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize(),
      this.$store.dispatch('loadPruebas')
    },

    methods: {
      initialize () {
      },

      toNormalDate(timestamp) {
        return moment(timestamp).format("DD/MM/YYYY");
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.$store.dispatch('deletePrueba', item);
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.selected = [];
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.$store.dispatch('savePrueba', {
            'item': this.editedItem,
            'selected': this.selected
          });
        }
        this.selected = [];
        this.close()
      },

      hidePick () {
        this.pickList = false;
        this.selected = [];
      },

      showPick () {
        this.pickList = true;
      },
    },
  }
</script>

<style scoped>
  .transparent-body {
    background: transparent
  }
</style>
